import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { Language } from '@zep/types/common';
import { cn } from '@zep/utils/tailwind';
import { Carousel, useCarousel } from '@zep/web-components';
import { getLandingImageUrl } from '../../../../consts/landingImages';
import { useLocale } from '../../../../hooks';
import { ProductDescription, ProductTheme } from './types';
interface MobileSliderViewProps {
  descriptions: readonly ProductDescription[];
  theme: ProductTheme;
}
export const MobileSliderView = ({
  descriptions,
  theme
}: MobileSliderViewProps) => {
  const locale = useLocale();
  const [sliderRef] = useCarousel({
    loop: false,
    mode: 'free',
    slides: {
      perView: 'auto',
      spacing: 16
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: {
          perView: 'auto',
          spacing: 24
        }
      }
    },
    rubberband: true
  });
  return <div className="w-full" data-sentry-component="MobileSliderView" data-sentry-source-file="MobileSliderView.tsx">
      <Carousel ref={sliderRef} className="pl-quiz-md tablet:pl-quiz-lg" data-sentry-element="Carousel" data-sentry-source-file="MobileSliderView.tsx">
        {descriptions.map(description => <ProductCard key={description.id} description={description} theme={theme} language={locale} />)}
        <Carousel.Slide className="!w-auto min-w-quiz-md shrink-0 tablet:min-w-quiz-lg" data-sentry-element="unknown" data-sentry-source-file="MobileSliderView.tsx" />
      </Carousel>
    </div>;
};
interface ProductCardProps {
  description: ProductDescription;
  theme: ProductTheme;
  language: Language;
}
const ProductCard = ({
  description,
  theme,
  language
}: ProductCardProps) => {
  const {
    t
  } = useTranslation(['home']);
  const imageUrl = getLandingImageUrl(description.imageKey, language);
  return <Carousel.Slide className="min-w-[310px] max-w-[310px] tablet:min-w-[370px] tablet:max-w-[370px]" data-sentry-element="unknown" data-sentry-component="ProductCard" data-sentry-source-file="MobileSliderView.tsx">
      <div className={cn('flex flex-col', 'rounded-quiz-lg', 'border border-quiz-opacity-black-5', 'overflow-hidden', 'h-full mb-quiz-md')} style={{
      backgroundColor: theme.backgroundColor
    }}>
        <div className="relative h-[280px] w-full overflow-hidden tablet:h-[383px]">
          <Image src={imageUrl} alt={t(description.title)} fill className="object-cover object-center" data-sentry-element="Image" data-sentry-source-file="MobileSliderView.tsx" />
          {/* Gradient Overlay */}
          <div className="absolute inset-x-0 bottom-0 flex h-[89px] items-center justify-center">
            <div className="h-[310px]  w-[89px] rotate-[270deg] tablet:h-[370px]" style={{
            background: `linear-gradient(to right, ${theme.backgroundColor}, ${theme.backgroundColor}00)`
          }} />
          </div>
        </div>

        <div className="flex flex-col gap-quiz-sm p-quiz-lg">
          <h3 className="text-quiz-heading-sm-bold text-quiz-gray-900 tablet:text-quiz-heading-md-bold">
            {t(description.title)}
          </h3>
          {description.description && <p className="d-regular text-quiz-body-md-medium text-quiz-gray-700 tablet:text-quiz-body-lg-medium">
              {t(description.description)}
            </p>}
        </div>
      </div>
    </Carousel.Slide>;
};